// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"styles_iconsWrapper__vz-15","arrowUp":"styles_arrowUp__1S6Yy","arrowDown":"styles_arrowDown__141Yv","iconsActive":"styles_iconsActive__24EyO"};